const normalizeId = (value) => {
  if (value === null || value === undefined) return "";
  return String(value);
};

const PrescriptionTemplateModal = ({
  isOpen,
  title = "Use Templates",
  selectedTemplateId,
  onSelectTemplate,
  onClose,
  closeOnSelect = true,
  loading = false,
  loadingText = "Loading templates...",
  emptyMessage = "No templates available.",
  showSearch = false,
  searchValue = "",
  searchPlaceholder = "Search templates...",
  onSearchChange,
  onSearchSubmit,
  onSearchClear,
  actionLabel = "Print",
  actionLoadingLabel = "Please wait...",
  isActionLoading = false,
  actionDisabled = false,
  onAction,
  templates = [],
}) => {
  if (!isOpen) return null;

  const handleSelect = (template) => {
    if (typeof onSelectTemplate === "function") {
      onSelectTemplate(template);
    }
    if (closeOnSelect && typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <div className="modal TemplateModal otherTemplateModal" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <button className="CloseButton" onClick={onClose}></button>
          <h3>{title}</h3>
        </div>

        <div className="modal-body">
          {showSearch ? (
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
              <input
                type="text"
                className="form_control"
                placeholder={searchPlaceholder}
                style={{ maxWidth: 320 }}
                value={searchValue}
                onChange={(e) => onSearchChange?.(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    onSearchSubmit?.();
                  }
                }}
              />
              <button className="downloadBtn" style={{ width: "auto", padding: "0 18px" }} onClick={() => onSearchSubmit?.()}>
                Search
              </button>
              <button
                className="downloadBtn"
                style={{ width: "auto", padding: "0 18px", background: "#6b7a8b" }}
                onClick={() => onSearchClear?.()}>
                Clear
              </button>
            </div>
          ) : null}

          <ul className="template-list">
            {loading ? (
              <li>
                <h4>{loadingText}</h4>
              </li>
            ) : null}

            {!loading && templates.length === 0 ? (
              <li>
                <h4>{emptyMessage}</h4>
              </li>
            ) : null}

            {!loading
              ? templates.map((template, index) => {
                const templateId = normalizeId(template?.id);
                const isSelected = normalizeId(selectedTemplateId) === templateId;
                const imageSrc = template?.template_image_url || template?.template_image || "";

                return (
                  <li key={templateId || `${template?.template_name || "template"}-${index}`} onClick={() => handleSelect(template)}>
                    <div className={`templateImg ${isSelected ? "selected" : ""}`}>
                      {imageSrc ? <img src={imageSrc} alt="Template" /> : <div className="np-text-soft">No image</div>}
                    </div>
                    <h4>{template?.template_name || "Unnamed template"}</h4>
                  </li>
                );
              })
              : null}
          </ul>

          {typeof onAction === "function" ? (
            <ul className="template-list buttonSec">
              <li className="downloadBtnSec">
                <button className="downloadBtn" disabled={actionDisabled || isActionLoading} onClick={onAction}>
                  {isActionLoading ? actionLoadingLabel : actionLabel}
                </button>
              </li>
            </ul>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PrescriptionTemplateModal;